import styled from '@emotion/styled';
import { FC } from 'react';

import CloseIcon from '@/assets/svg/ui-elements/close.svg';
import { typographyVariantStyles } from '@/design-system/typography-variants';

const ResetFiltersButtonStyled = styled('button')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: 8,
  color: theme.colors.text.error,
  ...typographyVariantStyles.body2,
  background: 'none',
  border: 'none',
  cursor: 'pointer',
}));

interface Props {
  onClick: () => void;
}

export const ResetFiltersButton: FC<Props> = ({ onClick }) => {
  return (
    <ResetFiltersButtonStyled onClick={onClick}>
      <span>Reset Filters</span>
      <CloseIcon width={16} height={16} />
    </ResetFiltersButtonStyled>
  );
};
